import { createAction } from '@src/redux/helpers/createAction';
import { validateTINSaga, notifyRCMTinSaga } from './sagas';
import { VALIDATE_TIN, SET_TIN, RESET_TIN_INFO, NOTIFY_RCM_TIN } from './constants';

export const validateTIN = (req, onSuccess, onError) => {
  return createAction({
    type: VALIDATE_TIN,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: validateTINSaga,
    },
  });
};

export const setTIN = (payload) => {
  return createAction({
    type: SET_TIN,
    payload,
  });
};

export const resetTINInfo = (payload) => {
  return createAction({
    type: RESET_TIN_INFO,
    payload,
  });
};

export const notifyRCMTin = (req, onSuccess, onError) => {
  return createAction({
    type: NOTIFY_RCM_TIN,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: notifyRCMTinSaga,
    },
  });
};
